import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from '@/i18n/translations'

Vue.use(VueI18n)

let domain = window.location.origin
let locale = ''

switch (domain) {
case `${process.env.LT_DOMAIN}`:
    locale = 'lt'
    break
case `${process.env.EN_DOMAIN}`:
    locale = 'en'
    break
default:
    locale = 'en'
}

document.querySelector('html').setAttribute('lang', locale)

export default new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: translations
})

// usage in html - {{$t("global.test")}}
// usage in attr - :attr="$t('global.test')"
// usage in js - this.$t('global.test')



// WEBPACK FOOTER //
// ./src/i18n/i18n.js